import { ReactNode } from 'react';
import styles from './style.module.scss';

type Props = {
  children: ReactNode
}

const NoticeSmall = ({ children }: Props) => {
  return (
    <div className={styles.noticeSmall}>
      {children}
    </div>
  )
}

export { NoticeSmall }
